<ll-titulo>{{ loggedLayoutTitle | easyplaceholder: "Edición" }}</ll-titulo>

<usuario-admin [usuarioId]="usuarioId" [enableShowCountryData]="true"></usuario-admin>
